export class PasswordResetConfirmModel {
    resetToken: string | null = null;
    newPassword: string | null = null;
    confirmNewPassword: string | null = null;

    constructor(data?: Partial<PasswordResetConfirmModel>) {
        Object.assign(this, data);
    }
}
